/**
 * Marketplace Module Container - Story 6.1-6.4: Seller Dashboard & Product Management
 * Routes and layout for marketplace/seller functionality
 */

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { MyProductsPage } from './pages/MyProductsPage';
import { AddProductPage } from './pages/AddProductPage';
import { EditProductPage } from './pages/EditProductPage';
import { ViewProductPage } from './pages/ViewProductPage';
import { InquiryInboxPage } from './pages/InquiryInboxPage';
import { ProductDetailPage } from './components/ProductDetailPage';

/**
 * MarketplaceModule Component
 * Routes for seller dashboard and product management
 *
 * Routes:
 * - /marketplace/seller/dashboard - Seller dashboard home (redirects to products)
 * - /marketplace/seller/products - My Products list
 * - /marketplace/products/new - Add new product (Story 6.3)
 * - /marketplace/products/:productId/edit - Edit product (Story 6.4)
 */
const MarketplaceModule: React.FC = () => {
  return (
    <Routes>
      {/* Redirect /marketplace to /marketplace/seller/products */}
      <Route path="/" element={<MyProductsPage />} />

      {/* Seller Dashboard - Story 6.1: Create Seller Dashboard Layout */}
      {/* Currently defaults to My Products page */}
      <Route path="/seller/dashboard" element={<MyProductsPage />} />

      {/* My Products - Story 6.2: Create My Products Page */}
      <Route path="/seller/products" element={<MyProductsPage />} />

      {/* Add Product - Story 6.3: Create Add Product Form */}
      <Route path="/products/new" element={<AddProductPage />} />
      {/* Alternative route for Add Product */}
      <Route path="/seller/products/add" element={<AddProductPage />} />

      {/* View Product - Read-only product view */}
      <Route path="/products/:productId/view" element={<ViewProductPage />} />

      {/* Edit Product - Story 6.4: Create Edit Product Form */}
      <Route path="/products/:productId/edit" element={<EditProductPage />} />

      {/* Inquiry Inbox - Story 6.5: Create Inquiry Inbox Page */}
      <Route path="/seller/inquiries" element={<InquiryInboxPage />} />

      {/* Public Product Detail - Story 7.3: Create Product Detail Page */}
      {/* Must be before catch-all route */}
      <Route path="/products/:externalId" element={<ProductDetailPage />} />

      {/* Default fallback - redirect to products */}
      <Route path="*" element={<MyProductsPage />} />
    </Routes>
  );
};

export default MarketplaceModule;
